export const DISPLAY_TABS = {
    'PRICE_CHANGES': 'Price',
    'STOCK_CHANGES': 'Stock'
}